import { useCompanySaleCheck } from "context/useCompanySaleCheck"
import { useOrders } from "context/useOrderData"
import { useProductConfiguration } from "context/useProductConfiguration"
import { Company, ManualVerificationStatus } from "models/Company"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { webShopService } from "services/Services"
import { UrlPath } from "utility/routes"
import BlackFridayLogoDiscountBanner from "../Webshop/DiscountPromo/BlackFridayLogoDiscountBanner"
import { useConfigPermission } from "context/useConfigPermission"
import EmptyConfigNagBanner from "./EmptyConfigNagBanner"

const CompanyAccessItem: React.FC<{ company: Company }> = ({ company }) => {


  const { saleStatusByCompany, fetchSaleStatus } = useOrders();
  const { companySaleCheck, fetchCompanySaleCheck } = useCompanySaleCheck();
  const { fetchProductConfigurations } = useProductConfiguration();
  const { fetchConfigPermissions } = useConfigPermission();
  const { canConfig } = useConfigPermission();

  useEffect(() => {
    fetchSaleStatus(company.id);
    fetchCompanySaleCheck(company.id, company.companyCode);
    fetchProductConfigurations(company.id);
    fetchConfigPermissions(company.id);
  }, []);

  return (
    <div className="card mb-4">
      
      <BlackFridayLogoDiscountBanner companyId={company.id}/>
      <EmptyConfigNagBanner id={company.id}/>
      <div className="card-body d-lg-flex justify-content-between align-items-stretch">
        <div className="text-center flex-grow-1 pb-2">
          <h2 className="h2">{company.name}</h2>
          <p className="mb-0 text-secondary">Org nr: {company.companyCode}</p>
          <p className="text-secondary">
            Juridisk navn: {company.legalName}
          </p>
          {company.manualVerificationStatus === ManualVerificationStatus.Pending && <p className="mb-4"><Link
              to={`${UrlPath.Account.Company}/${company.id}`}
              key={company.id}
              className="text-danger"
            >Lagrede endringer venter på 1881s godkjenning</Link></p>}
          <p className="mt-3 mb-3">
            <Link
              to={`${UrlPath.Account.Company}/${company.id}`}
              key={company.id}
              className="btn btn-primary text-white"
            >
              Endre opplysninger
            </Link>
          </p>
          {companySaleCheck[company.id]?.allowed ?
            <p className="mt-3 mb-3">
              <Link to={`${UrlPath.Account.WebShopBase}/${company.id}`}
                key={company.id}>
                Legg til ekstra informasjon om bedriften
              </Link>
            </p> : 
            null
            }
        </div>
        <div className="d-flex justify-content-center align-items-center cc-company-options">
          <ul className="list-unstyled cc-icon-list mb-3">
             {(company.hasStats || canConfig(company.id) )&& (
              <>
                {!company.hasProducts ? (
                  <li>
                    <i className="bi bi-box"></i> Vis kjøpte produkter
                  </li>
                ) : (<>
                  <li>
                    <Link to={`${UrlPath.Account.Company}/${company.id}/${UrlPath.Account.Actions.Products}`}>
                      <i className="bi bi-box"></i> Vis kjøpte produkter
                    </Link>
                  </li>

                </>
                )}

                {saleStatusByCompany[company.id] !== undefined && canConfig(company.id) ?
                  <li>
                    <Link to={`${UrlPath.Account.Company}/${company.id}/${UrlPath.Account.Actions.Ordre}`}>
                      <i className="bi bi-bag-check"></i> Se ordre
                    </Link>
                  </li>
                  :
                  <li>
                      <i className="bi bi-bag-check"></i> Se ordre
                  </li>
                }
                <li>
                  <Link
                    to={`${UrlPath.Account.Company}/${company.id}/${UrlPath.Account.Actions.Statistics}`}
                    state={{ iframeContent: "statistics" }}
                  >
                    <i className="bi bi-graph-up-arrow"></i> Vis statistikk
                  </Link>
                </li>
              </>
            )}
            <li>
              <Link to={`${UrlPath.Account.Company}/${company.id}/${UrlPath.Account.Actions.InfoSite}`} state={{ iframeContent: "infosite" }}>
                <i className="bi bi-info-square"></i> Se oppføring på 1881.no
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default CompanyAccessItem